import React from "react";

const SearchDarkBg = ({ size }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 64 64"
      >
        <defs>
          <path id="path-1" d="M.06 64H64V.04H.06z" />
        </defs>
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g>
            <g>
              <mask id="mask-2" fill="#fff">
                <use xlinkHref="#path-1" />
              </mask>
              <path
                fill="#FFFFFE"
                d="M37.744 33.3c-.11.21-.238.412-.364.616-.241.391-.5.775-.797 1.139a10.619 10.619 0 0 1-2.383 2.157c-.092.061-.19.11-.284.168a10.546 10.546 0 0 1-13.728-2.325 10.47 10.47 0 0 1-1.16-1.755 10.564 10.564 0 0 1-1.209-4.914c0-1.69.403-3.38 1.209-4.914a10.578 10.578 0 0 1 1.886-2.558 10.535 10.535 0 0 1 7.472-3.095c2.704 0 5.409 1.032 7.472 3.095a10.578 10.578 0 0 1 1.886 2.558 10.564 10.564 0 0 1 1.209 4.914c0 1.69-.403 3.38-1.209 4.914zm2.547 3.456c3.997-5.681 3.471-13.595-1.605-18.67a14.468 14.468 0 0 0-10.3-4.267 14.472 14.472 0 0 0-10.301 4.267c-5.679 5.679-5.679 14.921 0 20.6a14.472 14.472 0 0 0 10.301 4.267c3.043 0 5.937-.939 8.373-2.659l9.473 9.474A2.493 2.493 0 0 0 48 50.5a2.501 2.501 0 0 0 1.768-4.268l-9.477-9.476z"
                mask="url(#mask-2)"
              />
              <path
                fill="#4C5665"
                d="M49.768 49.768A2.493 2.493 0 0 1 48 50.5c-.64 0-1.28-.244-1.768-.732l-9.473-9.474a14.453 14.453 0 0 1-8.373 2.659 14.472 14.472 0 0 1-10.301-4.267c-5.679-5.679-5.679-14.921 0-20.6a14.472 14.472 0 0 1 10.301-4.267c3.891 0 7.549 1.515 10.3 4.267 5.076 5.075 5.602 12.989 1.605 18.67l9.477 9.476a2.501 2.501 0 0 1 0 3.536zM32 0C14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0z"
                mask="url(#mask-2)"
              />
            </g>
            <path
              fill="#4C5665"
              d="M35.858 20.914a10.535 10.535 0 0 0-7.472-3.095 10.535 10.535 0 0 0-7.472 3.095 10.578 10.578 0 0 0-1.886 2.558 10.564 10.564 0 0 0-1.209 4.914c0 1.69.403 3.38 1.209 4.914a10.47 10.47 0 0 0 1.886 2.558 10.543 10.543 0 0 0 13.002 1.522c.094-.058.192-.107.284-.168a10.619 10.619 0 0 0 2.383-2.157c.297-.364.556-.748.797-1.139.126-.204.254-.406.364-.616a10.564 10.564 0 0 0 1.209-4.914c0-1.69-.403-3.38-1.209-4.914a10.578 10.578 0 0 0-1.886-2.558"
            />
          </g>
        </g>
      </svg>
    </>
  );
};

export default SearchDarkBg;
